<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<section class="filters" [ngClass]="{ 'mobile-visible': isSidebarVisible }">
    <form action="">
        <div class="filter__title">
            <span>{{
                'fe_step2_list_vehicle_span_filter_title' | translate
            }}</span>
        </div>
        <button
            class="close-button d-lg-none d-blok"
            (click)="closeSidebar()"
            *ngIf="isSidebarVisible"
        >
            <span>{{
                'fe_step2_list_vehicle_span_filter_close_text' | translate
            }}</span>
        </button>
        <div class="filter__content">
            <div class="first__filter__content">
                <div class="filter__radiogroup">
                    <div class="radioRow" *ngIf="!international">
                        <input
                            class="filter__radio"
                            [id]="uid + '-featured'"
                            type="radio"
                            [name]="uid + '-radiogroup'"
                            value="featured"
                            [checked]="selectedRadio === 'featured'"
                            (change)="selectRadio('featured')"
                        />
                        <label class="filter__text" [for]="uid + '-featured'"
                            >{{
                                'fe_step2_list_vehicle_span_filter_option_featured'
                                    | translate
                            }}
                        </label>
                    </div>
                    <div class="radioRow">
                        <input
                            class="filter__radio"
                            [id]="uid + '-lowerPrice'"
                            type="radio"
                            [name]="uid + '-radiogroup'"
                            value="lowerPrice"
                            [checked]="selectedRadio === 'lowerPrice'"
                            (change)="selectRadio('lowerPrice')"
                        />
                        <label class="filter__text" [for]="uid + '-lowerPrice'"
                            >{{
                                'fe_step2_list_vehicle_span_filter_option_minor'
                                    | translate
                            }}
                        </label>
                    </div>
                    <div class="radioRow">
                        <input
                            class="filter__radio"
                            [id]="uid + '-higherPrice'"
                            type="radio"
                            [name]="uid + '-radiogroup'"
                            value="higherPrice"
                            [checked]="selectedRadio === 'higherPrice'"
                            (change)="selectRadio('higherPrice')"
                        />
                        <label class="filter__text" [for]="uid + '-higherPrice'"
                            >{{
                                'fe_step2_list_vehicle_span_filter_option_higher'
                                    | translate
                            }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </form>
</section>
